import styled from 'styled-components';

const MemberTable = styled.table`
  width: 100%;

  tr {
    vertical-align: baseline;
    text-align: left;
  }

  thead {
    background-color: black;
    color: white;
  }

  th {
    text-align: left;
  }

  th:nth-child(3), td:nth-child(3) {
    text-align: end;
  }

  td {
    padding: 5px 0;
  }
`

const Department = ({name, members}) => {
  return(
    <div>
      <div>
        <h2>{name}</h2>
      </div>
      { members.length > 0 ?
        <MemberTable>
          <thead>
            <tr>
              <th>TITLE</th>
              <th>NAME</th>
              <th>CONTACT INFO</th>
            </tr>
          </thead>
          <tbody>
            { members.map((member, index) => (
                <tr key={index}>
                  <td>{member.title.toUpperCase()}</td>
                  <td><b>{member.name.toUpperCase()}</b></td>
                  <td>
                    {member.phone && member.phone.length > 0 ? member.phone : null}
                    {member.email && member.email.length > 0 ? <>{member.phone && member.phone.length > 0 ? <br/> : null}{member.email}</> : null}
                  </td>
                </tr>
              ))
            }
          </tbody>
        </MemberTable> : null
      }
    </div>
  )
}

export default Department;
